import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ILoginHistory } from "./loginHistory.service.ajs";

@Injectable({
    providedIn: "root"
})
export class LoginHistoryService {

    constructor(
        private readonly http: HttpClient) {
    }

    getLatestLoginHistories(): Observable<ILoginHistory[]> {
        return this.http.get<ILoginHistory[]>(`/api/loginhistory/`);
    }

    getLatestLoginHistoryForUser(userId: number): Observable<ILoginHistory> {
        return this.http.get<ILoginHistory>(`/api/loginhistory/${userId}`);
    }


    getAllLoginHistoryForUser(userId: number, startTime: Date, endTime: Date): Observable<ILoginHistory[]> {
        const params = {
            startTime: startTime.toISOString(),
            endTime: endTime.toISOString()
        }
        return this.http.get<ILoginHistory[]>(`/api/loginhistory/${userId}/all`, { params });
    }
}
